import React, { Component } from "react";

import { BACKEND_CONFIG } from "../config/consts";
import assignmentsImg from "../images/icon-assignments.svg";
import addressesImg from "../images/addresses.svg";
import contactImg from "../images/contact.svg";
import underwritingImg from "../images/icon-underwriting.svg";
import upImg from "../images/up.svg";
import vehiclesImg from "../images/vehicles.svg";
import watercraftImg from "../images/watercraft.svg";
import driverImg from "../images/driver.svg";
import scheduledPropertyImg from "../images/scheduled_property.svg";

import AddressBody from "./client-panels/AddressesBody";
import ContactBody from "./client-panels/ContactBody";
import DriverBody from "./client-panels/DriverBody";
import VehicleBody from "./client-panels/VehicleBody";
import WatercraftBody from "./client-panels/WatercraftBody";
import AssignmentBody from "./client-panels/AssignmentBody";
import UnderwritingBody from "./client-panels/UnderwritingBody";
import ClientBody from "./client-panels/ClientBody";
import ScheduledPropertyBody from "./client-panels/ScheduledPropertyBody";

function getCollapsedDefault(props) {
  if (!props.data.Data) {
    return {};
  }

  switch (props.data.Title) {
    case "Vehicles":
    case "Watercrafts":
    case "Scheduled Properties":
    case "Drivers":
      return { collapsed: true };
    default:
      return {};
  }
}

class ClientCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAdditionalItems: false,
      collapsed: false,
      visible: BACKEND_CONFIG.get("allstateAgencyFeaturesAllowed"),
      ...getCollapsedDefault(props),
    };
  }

  render() {
    if (this.props.data.Title === "Underwriting" && this.state.visible) {
      return null;
    }

    let element;
    let elements = [];
    let elementsCount = 0;
    let isClient = false;
    let headerImg = undefined;

    if (this.props.data.Data) {
      switch (this.props.data.Title) {
        case "Addresses":
          elementsCount = this.props.data.Data.Addresses.length;
          for (let i = 0; i < this.props.data.Data.Addresses.length; i++) {
            elements.push(
              <AddressBody
                key={this.props.data.Data.Addresses[i].Id}
                data={this.props.data.Data.Addresses[i]}
              />
            );
          }
          headerImg = addressesImg;
          break;
        case "Contacts":
          elementsCount = this.props.data.Data.Contacts.length;
          for (let i = 0; i < this.props.data.Data.Contacts.length; i++) {
            elements.push(
              <ContactBody
                key={this.props.data.Data.Contacts[i].Id}
                data={this.props.data.Data.Contacts[i]}
              />
            );
          }
          headerImg = contactImg;
          break;
        case "Vehicles":
          elementsCount = this.props.data.Data.Vehicles.length;
          for (let i = 0; i < this.props.data.Data.Vehicles.length; i++) {
            elements.push(
              <VehicleBody
                key={this.props.data.Data.Vehicles[i].Id}
                data={this.props.data.Data.Vehicles[i]}
              />
            );
          }
          headerImg = vehiclesImg;
          break;
        case "Drivers":
          elementsCount = this.props.data.Data.Drivers.length;
          for (let i = 0; i < this.props.data.Data.Drivers.length; i++) {
            elements.push(
              <DriverBody
                key={this.props.data.Data.Drivers[i].Id}
                data={this.props.data.Data.Drivers[i]}
              />
            );
          }
          headerImg = driverImg;
          break;
        case "Watercrafts":
          elementsCount = this.props.data.Data.Watercrafts.length;
          for (let i = 0; i < this.props.data.Data.Watercrafts.length; i++) {
            elements.push(
              <WatercraftBody
                key={this.props.data.Data.Watercrafts[i].Id}
                data={this.props.data.Data.Watercrafts[i]}
              />
            );
          }
          headerImg = watercraftImg;
          break;
        case "Scheduled Properties":
          elementsCount = this.props.data.Data.ScheduledProperties.length;
          for (
            let i = 0;
            i < this.props.data.Data.ScheduledProperties.length;
            i++
          ) {
            elements.push(
              <ScheduledPropertyBody
                key={this.props.data.Data.ScheduledProperties[i].Id}
                data={this.props.data.Data.ScheduledProperties[i]}
              />
            );
          }
          headerImg = scheduledPropertyImg;
          break;
        case "Assignments":
          element = <AssignmentBody data={this.props.data.Data} />;
          headerImg = assignmentsImg;
          break;
        case "Underwriting":
          element = <UnderwritingBody data={this.props.data.Data} />;
          headerImg = underwritingImg;
          break;
        case "Client":
          element = (
            <ClientBody
              data={this.props.data.Data}
              isPersonal={
                this.props.additionalData &&
                this.props.additionalData.IsPersonalClient
              }
            />
          );
          isClient = true;
          break;
        default:
          break;
      }
    }

    let elementsCountStr = "";
    if (elementsCount > 1) {
      elementsCountStr = " (" + elementsCount + ")";
    }

    if (elements.length > 0) {
      element = elements.shift();
    }

    if (!this.state.showAdditionalItems) {
      elements = [];
    }

    let body = <div>Data temporarily unavailable</div>;
    if (this.props.data.Available) {
      body = (
        <div>
          {element}
          <div className="four-panel-small-content-elements">{elements}</div>
          {elementsCount > 1 && (
            <div className="four-panel-small-view-all">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                onClick={() => {
                  this.setState({
                    showAdditionalItems: !this.state.showAdditionalItems,
                  });
                }}
              >
                View {this.state.showAdditionalItems ? "Less" : "All"}{" "}
                {this.props.data.Title} <img alt="" />
              </a>
            </div>
          )}
        </div>
      );
    }

    let panelClassName = "four-panel-small";
    if (isClient) {
      panelClassName += " four-panel-small-client";
    } else {
      panelClassName += " four-panel-small-margin-top";
    }

    return (
      <div className={panelClassName}>
        {!isClient && (
          <div className="four-panel-small-header">
            {headerImg && (
              <img
                alt="logo"
                className="four-panel-small-header-logo"
                src={headerImg}
              />
            )}
            <span>
              {this.props.data.Title}
              {elementsCountStr}
            </span>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              className={
                "arrow" + (this.state.collapsed ? " arrow-collapsed" : "")
              }
              onClick={() => {
                this.setState({ collapsed: !this.state.collapsed });
              }}
            >
              <img alt="" src={upImg} />
            </a>
          </div>
        )}
        {!this.state.collapsed && (
          <div className="four-panel-small-content">{body}</div>
        )}
      </div>
    );
  }
}

export default ClientCard;
